import { Descriptions, Divider } from "antd";
import { selectCurrentBusiness } from "../../../businessesSlice";
import { useAppSelector } from "../../../../../app/hooks";
import { MissingTag } from "../BusinessDetailsModal";
import { getFullDate } from "../../../utils/getFullDate";

export default function BusinessTransactionsInfo() {
  const currentBusiness = useAppSelector(selectCurrentBusiness);
  return (
    <>
      <Descriptions
        title="Transaction Info"
        labelStyle={{ opacity: 0.6, width: "130px" }}
      >
        <Descriptions.Item label="First Tsx Date">
          {currentBusiness.firstTsxDate
            ? getFullDate(new Date(currentBusiness.firstTsxDate).toISOString())
            : MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="Terminal ID">
          {currentBusiness.terminalId || MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="Agreement Id">
          {currentBusiness.agreementId || MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="MID">
          {currentBusiness.mid || MissingTag}
        </Descriptions.Item>
        {currentBusiness.phosMerchantToken && (
          <Descriptions.Item label="Phos Merchant Id">
            {currentBusiness.phosMerchantToken || MissingTag}
          </Descriptions.Item>
        )}

        <Descriptions.Item label="Yazara Merchant Id">
          {currentBusiness.yazaraMerchantId || MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="Yazara Terminal Count">
          {currentBusiness.yazaraTerminals?.length > 0
            ? currentBusiness.yazaraTerminals?.length
            : MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="Vat">{currentBusiness.vat}</Descriptions.Item>
      </Descriptions>
      <Divider />
      <Descriptions
        title="Expected Transaction Volumes"
        labelStyle={{ opacity: 0.6, width: "130px" }}
      >
        <Descriptions.Item label="Average Monthly Volume ">
          {currentBusiness.transactionInformation?.averageMonthlyVolume}
        </Descriptions.Item>
        <Descriptions.Item label="Average Monthly Count">
          {
            currentBusiness.transactionInformation
              ?.expectedAverageMonthlyNumberOfTransactions
          }
        </Descriptions.Item>
        <Descriptions.Item label="Average Transaction Value">
          {
            currentBusiness.transactionInformation
              ?.expectedAverageTransactionAmount
          }
        </Descriptions.Item>
        <Descriptions.Item label="Maximum Transaction Amount">
          {
            currentBusiness.transactionInformation
              ?.expectedMaximumTransactionAmount
          }
        </Descriptions.Item>
      </Descriptions>
    </>
  );
}
